export const getAccessToken="https://6zqeqxesw2.execute-api.ap-south-1.amazonaws.com/default/getV2AccessToken";
export const aliceblueWebsocketUrl="wss://ws1.aliceblueonline.com/NorenWS/";

export const aliceBlueLoginRedirectUrl="https://ant.aliceblueonline.com/?appcode=NOtCbkfhSShbzZJ";
export const aliceBlueSignUpRedirectUrl="https://alicebluepartner.com/open-myaccount/";


export const landingPageURL="https://1lyoptions.com";

export const placeOrderUrl="https://ant.aliceblueonline.com/rest/AliceBlueAPIService/api/placeOrder/executePlaceOrder";
export const modifyOrderUrl="https://ant.aliceblueonline.com/rest/AliceBlueAPIService/api/placeOrder/modifyOrder";

export const getOrderHistoryUrl="https://ant.aliceblueonline.com/rest/AliceBlueAPIService/api/placeOrder/orderHistory";